
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-c8ed5fec&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ReceiptVoucher.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ReceiptVoucher.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-c8ed5fec!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ReceiptVoucher.vue"),
  /* scopeId */
  "data-v-c8ed5fec",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/accounting/ReceiptVoucher.vue
// module id = 715
// module chunks = 0